import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 2H10V22H4V2Z" fill={ fill || 'currentColor' } />
        <path d="M14 2H20V22H14V2Z" fill={ fill || 'currentColor' } />
    </svg>

);
